(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hl-announcement-ticker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-announcement-ticker')) {
    customElements.define('hl-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.resizeObserver) return;
        const button = this.querySelector('button');
        const track = this.querySelector('.hl-ticker__track');
        const group = this.querySelector('.hl-ticker__group');
        const viewport = this.querySelector('.hl-ticker__window');
        if (!button || !track || !group || !viewport) return;
        this.measure = () => {
          if (!this.isConnected) return;
          const width = group.getBoundingClientRect().width;
          if (!width) return;
          const copies = Math.max(2, Math.ceil(viewport.clientWidth / width) + 1);
          while (track.children.length < copies) {
            const clone = group.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.append(clone);
          }
          while (track.children.length > copies) track.lastElementChild.remove();
          track.style.setProperty('--hl-ticker-cycle', `${width}px`);
          track.style.setProperty('--hl-ticker-duration', `${width / 33}s`);
        };
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(viewport);
        this.resizeObserver.observe(group);
        this.measure();
        document.fonts.ready.then(this.measure);
        button.onclick = () => {
          const paused = this.toggleAttribute('paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
          button.textContent = paused ? button.dataset.play : button.dataset.pause;
        };
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-cart-clarity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-cart-clarity')) {
    customElements.define('hl-cart-clarity', class extends HTMLElement {
      connectedCallback() {
        try { this.words = JSON.parse(this.querySelector('script').textContent); } catch { return; }
        if (!this.words || typeof this.words !== 'object') return;
        this.attempts = 0;
        this.cartVersion = 0;
        this.cart = null;
        this.connect();
      }
      disconnectedCallback() {
        clearTimeout(this.connectTimer);
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.abort?.abort();
        this.unsubscribe?.();
      }
      connect() {
        if (!this.isConnected) return;
        this.root = document.querySelector('#recharge-storefront-experiences__cart-drawer')?.shadowRoot;
        const events = window.RechargePubSub;
        if (!this.root || !events?.subscribe) {
          if (++this.attempts < 120) this.connectTimer = setTimeout(() => this.connect(), 500);
          return;
        }
        this.ensureStyle();
        this.observer = new MutationObserver(() => this.schedule());
        // Decorate Recharge's confirmed cart instead of feeding a second cart
        // read back through its request interceptor while gifts are syncing.
        this.unsubscribe = events.subscribe('cart:update', ({ cart } = {}) => {
          if (!Array.isArray(cart?.items)) return;
          this.abort?.abort();
          this.cart = cart;
          this.cartVersion += 1;
          this.schedule();
        });
        this.observe();
        this.schedule();
      }
      observe() {
        this.observer.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled', 'data-state'] });
      }
      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 180);
      }
      text(key, values = {}) {
        return Object.entries(values).reduce((s, [k, v]) => s.replaceAll('[' + k + ']', v), this.words[key] || '');
      }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.currency || this.dataset.currency }).format(cents / 100);
      }
      note(parent, key, value, before = null, tag = 'p') {
        let node = parent.querySelector(':scope > [data-hl-cart="' + key + '"]');
        if (!value) { node?.remove(); return null; }
        if (!node) {
          node = document.createElement(tag);
          node.dataset.hlCart = key;
          node.className = 'hl-cart-' + key;
          parent.insertBefore(node, before);
        }
        if (node.textContent !== value) node.textContent = value;
        return node;
      }
      nativeSignature() {
        const cart = this.root.querySelector('#CartSheet[data-state="open"]');
        if (!cart) return '';
        return [...cart.querySelectorAll('section[role="list"] > [role="listitem"]')].map(item => {
          const copy = item.cloneNode(true);
          copy.querySelectorAll('[data-hl-cart]').forEach(n => n.remove());
          return copy.textContent + '|' + item.querySelector('input[name="quantity"]')?.value + '|' + item.querySelector('select[name="selling_plan"]')?.value;
        }).join('||') + '|' + [...cart.querySelectorAll('footer [part~="money"], header [role="progressbar"], header [part="progress--icon"]')].map(n => n.textContent + n.getAttribute('style') + n.getAttribute('data-value')).join('|');
      }
      async refresh() {
        const signature = this.nativeSignature();
        if (!signature) { this.signature = ''; return; }
        const version = this.cartVersion;
        const revision = version + '|' + signature;
        if (revision === this.signature) return;
        this.signature = revision;
        this.abort?.abort();
        this.abort = new AbortController();
        this.clearPrices();
        try {
          let cart = this.cart;
          if (!cart) {
            // Recharge uses this flag for read-only internal requests. Without
            // it, a stale response can overwrite its newer cart state.
            const response = await fetch(this.dataset.root + 'cart.js?recharge=true', { credentials: 'same-origin', cache: 'no-store', signal: this.abort.signal });
            if (!response.ok) throw new Error('cart');
            cart = await response.json();
          }
          if (this.cartVersion !== version || this.nativeSignature() !== signature) return;
          this.cart = cart;
          this.currency = cart.currency;
          this.observer.disconnect();
          try { this.decorate(cart); } finally { this.observe(); }
        } catch {
          if (this.signature === revision) this.signature = '';
        }
      }
      clearPrices() {
        this.observer.disconnect();
        this.root.querySelectorAll('[data-hl-cart]').forEach(n => n.remove());
        this.root.querySelectorAll('.hl-cart-native-plan').forEach(n => n.classList.remove('hl-cart-native-plan'));
        this.root.querySelectorAll('.hl-cart-native-saving').forEach(n => n.classList.remove('hl-cart-native-saving'));
        this.observe();
      }
      match(item, cart) {
        const title = item.querySelector('p.font-semibold')?.textContent.trim();
        const paragraphs = [...item.querySelectorAll('dl > p')].map(p => p.textContent.trim());
        const quantity = Number(item.querySelector('input[name="quantity"]')?.value);
        const plan = item.querySelector('select[name="selling_plan"]')?.value;
        const candidates = cart.items.filter(line => line.product_title === title && line.quantity === quantity &&
          (!line.variant_title || line.variant_title === 'Default Title' || paragraphs.includes(line.variant_title)) &&
          (plan && plan !== 'ONETIME' ? String(line.selling_plan_allocation?.selling_plan?.id) === plan : !line.selling_plan_allocation));
        return candidates.length === 1 ? candidates[0] : null;
      }
      planParts(name) {
        const match = (name || '').match(/^(\d+) products? every (\d+) days? at (\d+(?:\.\d+)?)% discount$/i);
        return match ? { quantity: Number(match[1]), days: Number(match[2]), percent: Number(match[3]) } : null;
      }
      unit(line, quantity) {
        const powders = ['hydrate', 'creatine-monohydrate', 'creatine-x', 'pd-special', 'eaax', 'shadow', 'berserker-stim', 'berserker-focus', 'flood'];
        return this.text(powders.includes(line.handle) ? (quantity === 1 ? 'tub' : 'tubs') : (quantity === 1 ? 'item' : 'items'));
      }
      ensureStyle() {
        if (!this.root.querySelector('[data-hl-cart-style]')) {
          const style = document.createElement('style');
          style.dataset.hlCartStyle = '';
          style.textContent = `
            [data-hl-cart]{margin:0;font-family:Arial,sans-serif;line-height:1.45;font-size:13px;letter-spacing:0}
            .hl-cart-type{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.055em;margin-top:5px;color:#176b93}
            .hl-cart-summary{margin-top:5px;color:#354650}
            .hl-cart-rate{font-weight:600;color:#354650;margin-top:2px}
            .hl-cart-locked{color:#53616b;padding-top:2px}
            .hl-cart-saving{color:#16833a;font-size:12px;font-weight:700;margin-top:3px;white-space:normal}
            .hl-cart-shipping{color:#16833a;font-weight:700;text-align:center;margin-bottom:5px}
            .hl-cart-native-plan,.hl-cart-native-saving{display:none!important}
            .hl-cart-plan-label{font-size:0!important}
            .hl-cart-plan-label::after{content:attr(data-hl-label);font-size:14px}
            #cart-drawer [role=listitem]>div:has(>button.bg-storefront-drawer-secondary):not(:has(select,input)){display:none!important}
            #cart-drawer input[name=quantity]{font-size:16px}
            #cart-drawer select[name=selling_plan]{min-height:44px;font-size:16px}
            #cart-drawer button[name=checkout]{min-height:46px}
            #cart-drawer header button,#cart-drawer [role=listitem] button:has(.lucide-trash2){min-width:44px;min-height:44px}
            @media(max-width:749px){#cart-drawer [role=listitem]>div:first-child{align-items:flex-start}#cart-drawer [role=listitem]>div:first-child>img{object-fit:contain}.hl-cart-rate{font-size:12px}}
          `;
          this.root.append(style);
        }
      }
      decorate(cart) {
        this.ensureStyle();
        for (const item of this.root.querySelectorAll('section[role="list"] > [role="listitem"]')) {
          const line = this.match(item, cart);
          if (!line) continue;
          const details = item.querySelector('dl');
          if (!details) continue;
          const allocation = line.selling_plan_allocation;
          const gift = Boolean(line.properties?._rc_free_gift);
          const plan = allocation?.selling_plan;
          const parts = this.planParts(plan?.name);
          const info = details.parentElement;
          this.note(info, 'type', this.text(gift ? 'gift' : allocation ? 'subscription' : 'one_time'));
          this.note(info, 'summary', parts ? this.text('cadence', { quantity: line.quantity, unit: this.unit(line, line.quantity), days: parts.days }) : '');
          details.querySelectorAll('p').forEach(p => p.classList.toggle('hl-cart-native-plan', Boolean(parts && p.textContent.trim() === plan.name)));
          if (allocation && Number.isFinite(allocation.per_delivery_price)) {
            this.note(info, 'rate', this.text('rate', { price: this.money(allocation.per_delivery_price * line.quantity) }));
          }
          const quantityInput = item.querySelector('input[name="quantity"]');
          const quantityRow = quantityInput?.closest('div.flex.gap-2.justify-between');
          if (quantityRow) this.note(quantityRow.parentElement, 'locked', allocation && quantityInput.disabled ? this.text('locked') : '');
          const select = item.querySelector('select[name="selling_plan"]');
          if (select) {
            const label = [...item.querySelectorAll('label')].find(n => n.htmlFor === select.id);
            if (label) { label.classList.add('hl-cart-plan-label'); label.dataset.hlLabel = this.text('change_plan'); }
            select.setAttribute('aria-label', this.text('change_plan'));
          }
          const current = item.querySelector('[part~="discount"]');
          const original = current?.parentElement.querySelector('[part~="money"].line-through');
          if (current && original) {
            const parse = node => /^\$[\d,]+\.\d{2}$/.test(node.textContent.trim()) ? Math.round(Number(node.textContent.replace(/[$,]/g, '')) * 100) : NaN;
            const before = parse(original), after = parse(current), difference = before - after;
            if (cart.currency === 'USD' && difference > 0 && after === line.final_line_price) {
              const native = [...current.parentElement.children].find(n => /^Saving \d+(?:\.\d+)?%$/.test(n.textContent.trim()));
              native?.classList.add('hl-cart-native-saving');
              this.note(current.parentElement, 'saving', this.text('saving', { amount: this.money(difference), percent: Math.round(difference * 100 / before) }));
            }
          }
        }
        const header = this.root.querySelector('#cart-drawer header');
        const shippingIcon = header?.querySelector('[part="progress--icon"] img[src$="/shipping.svg"]')?.parentElement;
        const indicator = header?.querySelector('[part="progress--indicator"]');
        const progress = header?.querySelector('[role="progressbar"]');
        const earned = shippingIcon && indicator && progress && getComputedStyle(shippingIcon).backgroundColor === getComputedStyle(indicator).backgroundColor && getComputedStyle(shippingIcon).backgroundColor !== getComputedStyle(progress).backgroundColor;
        const rewardBlock = progress?.parentElement?.parentElement;
        if (earned && rewardBlock && this.dataset.country === 'US' && cart.currency === 'USD') {
          this.note(rewardBlock, 'shipping', this.text('shipping'), rewardBlock.firstChild);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-gift-card-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-gift-card')) {
    customElements.define('hl-gift-card', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('change', event => {
          const option = event.target.closest('[data-hlgc-option]');
          if (!option) return;
          const form = document.getElementById(this.dataset.formId);
          const variantInput = form?.querySelector('input[name="id"]');
          if (!variantInput) return;
          variantInput.value = option.value;
          variantInput.disabled = option.dataset.available !== 'true';
          variantInput.dispatchEvent(new Event('change', {bubbles:true}));
          this.querySelector('[data-hlgc-price]').textContent = option.dataset.price;
          this.querySelector('[data-hlgc-value]').textContent = option.dataset.value;
          const recipient = this.querySelector('recipient-form');
          if (recipient) recipient.dataset.productVariantId = option.value;
          const productForm = this.querySelector('product-form');
          productForm?.toggleSubmitButton(option.dataset.available !== 'true');
          productForm?.handleErrorMessage();
          const url = new URL(location.href);
          url.searchParams.set('variant',option.value);
          history.replaceState({},'',url);
        }, {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-header-search')) {
    customElements.define('hl-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.panel = this.querySelector('[role="dialog"]');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-hl-search-content]');
        this.status = this.querySelector('[data-hl-search-status]');
        this.suggestions = this.querySelector('[data-hl-search-suggestions]');
        this.triggers = [...document.querySelectorAll('[data-hl-search-trigger]')].filter(node => node.dataset.hlSearchTrigger === this.dataset.headerId);
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.triggers.forEach(trigger => {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.panel.id);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.addEventListener('click', event => {
            event.preventDefault();
            if (this.panel.hidden) this.open(trigger); else this.close(true);
          }, options);
          trigger.addEventListener('keydown', event => {
            if (event.key === ' ') { event.preventDefault(); trigger.click(); }
          }, options);
        });
        this.querySelector('[data-hl-search-close]').addEventListener('click', () => this.close(true), options);
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          this.search();
        }, options);
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.request?.abort();
          this.results.replaceChildren();
          this.status.textContent = '';
          this.suggestions.hidden = Boolean(this.input.value.trim());
          if (this.input.value.trim()) this.timer = setTimeout(() => this.search(), 220);
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.panel.hidden && !this.contains(event.target) && !this.triggers.some(trigger => trigger.contains(event.target))) this.close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.panel.hidden) { event.preventDefault(); this.close(true); }
        }, options);
        this.addEventListener('focusout', () => {
          setTimeout(() => {
            if (this.isConnected && !this.contains(document.activeElement) && !this.triggers.includes(document.activeElement)) this.close();
          }, 0);
        }, options);
        this.panel.addEventListener('keydown', event => {
          if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
          const links = [...this.results.querySelectorAll('a')];
          if (!links.length) return;
          const index = links.indexOf(document.activeElement);
          if (document.activeElement !== this.input && index < 0) return;
          event.preventDefault();
          const next = event.key === 'ArrowDown' ? index + 1 : index - 1;
          if (next < 0) this.input.focus(); else links[Math.min(next, links.length - 1)].focus();
        }, options);
        window.addEventListener('resize', () => { if (!this.panel.hidden) this.position(); }, options);
        window.addEventListener('scroll', () => { if (!this.panel.hidden) this.close(); }, { ...options, passive: true });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.request?.abort();
        clearTimeout(this.timer);
      }
      position() {
        const header = document.querySelector('.header-' + CSS.escape(this.dataset.headerId));
        const bottom = header?.getBoundingClientRect().bottom || 80;
        const height = window.visualViewport?.height || innerHeight;
        const top = Math.min(Math.max(12, bottom + 8), Math.max(12, height - 240));
        const preview = document.querySelector('#PBarNextFrame')?.getBoundingClientRect();
        const previewHeight = preview && preview.width > 0 && preview.bottom >= innerHeight - 2 ? Math.min(64, Math.max(0, innerHeight - preview.top)) : 0;
        this.panel.style.setProperty('--hl-search-top', top + 'px');
        this.panel.style.setProperty('--hl-search-height', Math.max(180,height - top - previewHeight - 16) + 'px');
      }
      open(trigger) {
        this.returnFocus = trigger;
        this.panel.hidden = false;
        this.triggers.forEach(node => node.setAttribute('aria-expanded','true'));
        document.querySelectorAll('.hl-menu-trigger[aria-expanded="true"]').forEach(node => node.click());
        this.position();
        this.input.focus({ preventScroll: true });
        if (this.input.value.trim()) this.search();
      }
      close(focus = false) {
        if (this.panel.hidden) return;
        this.panel.hidden = true;
        this.triggers.forEach(node => node.setAttribute('aria-expanded','false'));
        this.request?.abort();
        clearTimeout(this.timer);
        this.results.removeAttribute('aria-busy');
        if (focus) this.returnFocus?.focus({ preventScroll: true });
      }
      async search() {
        clearTimeout(this.timer);
        this.request?.abort();
        const query = this.input.value.trim();
        if (!query) { this.results.replaceChildren(); this.status.textContent = ''; this.suggestions.hidden = false; return; }
        const request = new AbortController();
        this.request = request;
        this.status.textContent = this.dataset.loading;
        this.suggestions.hidden = true;
        this.results.setAttribute('aria-busy','true');
        try {
          const url = new URL(this.dataset.endpoint, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('section_id', 'hl-header-search-results');
          const response = await fetch(url, { credentials: 'same-origin', signal: request.signal });
          if (!response.ok) throw new Error('search');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-hl-search-response]');
          if (!html) throw new Error('search');
          if (request.signal.aborted || this.panel.hidden || this.input.value.trim() !== query) return;
          this.results.replaceChildren(html);
          const count = Number(html.dataset.count);
          this.status.textContent = count ? this.dataset.results.replace('[count]', count) : this.dataset.empty;
        } catch (error) {
          if (error.name !== 'AbortError' && this.request === request && !this.panel.hidden) {
            this.results.replaceChildren();
            this.status.textContent = this.dataset.error;
            this.suggestions.hidden = false;
          }
        } finally {
          if (this.request === request) this.results.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-product-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-product-links')) {
  customElements.define('hl-product-links', class extends HTMLElement {
    connectedCallback() {
      this.entries = new Map([["Stitched Trucker Hat - Olive Green / Black", "stitched-trucker-hat-olive-green-black"], ["Hollow Old English Tee - Military Green", "hollow-old-english-tee-military-green"], ["Acrylic Patch Trucker Hat - Olive / Tan", "acrylic-patch-trucker-hat-olive-tan"], ["Acrylic Patch Trucker Hat - Forest Camo", "acrylic-patch-trucker-hat-forest-camo"], ["Acrylic Patch Trucker Hat - Green Camo", "acrylic-patch-trucker-hat-green-camo"], ["Stitched Trucker Hat - Black / Blue", "stitched-trucker-hat-black-blue"], ["Stitched Trucker Hat - Tan / Brown", "stitched-trucker-hat-tan-brown"], ["Stitched Trucker Hat - Black Camo", "stitched-trucker-hat-black-camo"], ["Acrylic Patch Trucker Hat - Black", "acrylic-patch-trucker-hat-black"], ["Acrylic Patch Trucker Hat - Navy", "acrylic-patch-trucker-hat-navy"], ["You Need Jiu Jitsu Tee - Black", "you-need-jiu-jitsu-tee-black"], ["Berserker Tee - Military Green", "berserker-tee-military-green"], ["You Need Jiu Jitsu Tee - Navy", "you-need-jiu-jitsu-tee-navy"], ["Hollow Legend Shaker (40 oz)", "hollow-legend-shaker-40-oz"], ["Berserker Stim™ Pre-Workout", "berserker-stim"], ["American Flag Tank - Black", "american-flag-tank-black"], ["Hollow Labs Shaker Bottle", "hollow-labs-shaker-bottle"], ["Hollow Labs USA Rashguard", "hollow-labs-usa-rashguard"], ["American Flag Tee - Black", "american-flag-tee-black"], ["Hollow Ice Shaker (32oz)", "hollow-labs-shaker"], ["Men's Performance Stack", "mens-performance-stack"], ["Berserker Tee - Black", "berserker-tee-black"], ["Creatine Monohydrate", "creatine-monohydrate"], ["Hybrid Athlete Stack", "hybrid-athlete-stack"], ["Berserker Tee - Tan", "berserker-tee-tan"], ["Hollow OG Pre Stack", "hollow-og-pre-stack"], ["Competitors Stack", "competitors-stack"], ["Hollow Gift Card", "hollow-labs-gift-card"], ["Berserker Focus", "berserker-focus"], ["Berserker Serum", "berserker-serum"], ["Berserker Stack", "berserker-stack"], ["Recovery Stack", "recovery-stack"], ["Wellness Stack", "wellness-stack"], ["Berserker Stim", "berserker-stim"], ["Shadow Realm", "shadow-realm"], ["Health Stack", "health-stack"], ["Elite Joint", "elite-joint"], ["Liver Guard", "liver-guard"], ["Omega D3/K2", "omega-d3-k2"], ["Elite-Joint", "elite-joint"], ["Creatine X", "creatine-x"], ["Magnesium+", "magnesium"], ["Vita Focus", "vita-focus"], ["PD Special", "pd-special"], ["CreatineX", "creatine-x"], ["Flood V2", "flood"], ["Rapture", "rapture"], ["Hydrate", "hydrate"], ["EAAX V2", "eaax"], ["Shadow", "shadow"], ["Ignite", "ignite"], ["EAA X", "eaax"], ["Flood", "flood"], ["Serum", "berserker-serum"], ["EAAX", "eaax"]]);
      this.matcher = new RegExp('(?<![\\p{L}\\p{N}])(?:' + Array.from(this.entries.keys(), name => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')(?![\\p{L}\\p{N}])', 'gu');
      this.applyLinks = () => this.linkContent(document.querySelector('main'));
      this.sectionLoaded = event => this.linkContent(event.target);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.applyLinks, { once: true });
      else this.applyLinks();
      document.addEventListener('shopify:section:load', this.sectionLoaded);
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.applyLinks);
      document.removeEventListener('shopify:section:load', this.sectionLoaded);
    }
    linkContent(root) {
      if (!root || !root.closest('main')) return;
      const prose = 'p,li,dd,dt,td,th,h2,h3,h4,blockquote,.rte,.product__description';
      const skip = 'a,button,summary,form,label,select,option,script,style,template,code,pre,svg,nav,[role="button"],[role="link"],[contenteditable],[aria-hidden="true"],cart-drawer,cart-items,product-form,recharge-subscription-widget,.jdgm-widget,.yotpo';
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const parent = node.parentElement;
        if (!parent || !parent.closest(prose) || parent.closest(skip)) continue;
        this.matcher.lastIndex = 0;
        if (this.matcher.test(node.data)) nodes.push(node);
      }
      for (const node of nodes) {
        this.matcher.lastIndex = 0;
        const fragment = document.createDocumentFragment();
        let cursor = 0;
        let changed = false;
        for (const match of node.data.matchAll(this.matcher)) {
          const handle = this.entries.get(match[0]);
          if (handle === this.dataset.currentProduct) continue;
          fragment.append(document.createTextNode(node.data.slice(cursor, match.index)));
          const anchor = document.createElement('a');
          anchor.className = 'hl-product-link';
          anchor.href = this.dataset.root.replace(/\/$/, '') + '/products/' + handle;
          anchor.textContent = match[0];
          fragment.append(anchor);
          cursor = match.index + match[0].length;
          changed = true;
        }
        if (changed) {
          fragment.append(document.createTextNode(node.data.slice(cursor)));
          node.replaceWith(fragment);
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-sticky-cart')) {
    customElements.define('hl-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-hl-variants]').textContent);
        this.addButton = this.querySelector('.hl-sticky__add');
        this.editButton = this.querySelector('.hl-sticky__edit');
        this.image = this.querySelector('.hl-sticky__image');
        this.defaultImage = this.image?.getAttribute('src');
        this.abort = new AbortController();
        this.boundForms = new WeakSet();
        const options = { signal: this.abort.signal };
        this.addButton.addEventListener('click', () => this.add(), options);
        this.editButton.addEventListener('click', () => this.edit(), options);
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        document.addEventListener('change', event => {
          if (this.info?.contains(event.target)) this.settlingUntil = Date.now() + 700;
          this.schedule();
        }, options);
        document.addEventListener('input', this.schedule, options);
        this.timer = setInterval(this.schedule, 350);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearInterval(this.timer);
        cancelAnimationFrame(this.frame);
        this.reserve?.remove();
      }
      setText(selector, text) {
        const node = this.querySelector(selector);
        if (node.textContent !== text) node.textContent = text;
      }
      getState() {
        this.info = document.querySelector('main product-info[id^="MainProduct-"]');
        if (!this.info) return null;
        const form = this.info.querySelector('product-form form[action*="/cart/add"]');
        const button = form?.querySelector('[type="submit"][name="add"]');
        const variantId = form?.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === variantId);
        if (!button || !variant) return null;
        if (!this.boundForms.has(form)) {
          form.addEventListener('formdata', event => {
            const selection = this.getState();
            if (selection?.ready && !selection.subscription && Number.isInteger(selection.quantity) && selection.quantity > 0) {
              event.formData.set('quantity', String(selection.quantity));
            }
          }, { signal: this.abort.signal });
          this.boundForms.add(form);
        }
        let quantity = Number(this.info.querySelector('.product-form__quantity input[name="quantity"]')?.value || 1);
        let total = variant.price * quantity;
        let plan = this.dataset.once + ' · ' + this.dataset.units.replace('[quantity]', quantity);
        let subscription = false;
        let ready = true;
        const widget = this.info.querySelector('recharge-subscription-widget');
        if (this.dataset.subscriptions === 'true') {
          const root = widget?.shadowRoot?.querySelector('recharge-quantity-upsell')?.shadowRoot;
          const selected = root?.querySelector('[rc-selected]');
          const input = selected?.querySelector('input[name="quantityUpsellOption"]');
          ready = Boolean(input);
          if (input?.value) {
            subscription = true;
            const titleNode = selected.querySelector('.rc-quantity-upsell-option__title');
            const title = titleNode ? [...titleNode.childNodes].filter(n => n.nodeType === 3).map(n => n.textContent).join('').trim() : '';
            const parts = title.match(/^(\d+) products? every (\d+) days?/i);
            const priceText = selected.querySelector('.rc-quantity-upsell-option__header')?.lastElementChild?.textContent || '';
            const price = priceText.replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
            ready = Boolean(parts && price && this.dataset.currency === 'USD');
            if (ready) {
              quantity = Number(parts[1]);
              total = Math.round(Number(price[1]) * 100);
              plan = (quantity === 1 ? this.dataset.single : this.dataset.bundle).replace('[quantity]', quantity).replace('[days]', parts[2]);
            }
          }
        }
        const blocked = button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading');
        return { form, button, variant, quantity, total, plan, subscription, ready, blocked };
      }
      overlayOpen() {
        return [...document.querySelectorAll('[aria-modal="true"],dialog[open],cart-drawer.active')].some(node => {
          const rect = node.getBoundingClientRect();
          const style = getComputedStyle(node);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
        }) || getComputedStyle(document.body).overflowY === 'hidden';
      }
      update() {
        if (!this.isConnected) return;
        const state = this.getState();
        if (!state) { this.hidden = true; return; }
        this.state = state;
        const currency = this.dataset.currency || 'USD';
        if (state.subscription && currency !== 'USD') {
          this.hidden = true;
          if (this.reserve) this.reserve.style.height = '0px';
          return;
        }
        const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(value / 100);
        this.setText('.hl-sticky__variant', state.variant.title === 'Default Title' ? '' : state.variant.title);
        if (this.image) {
          const image = state.variant.image || this.defaultImage;
          if (image && this.image.getAttribute('src') !== image) {
            this.image.removeAttribute('srcset');
            this.image.setAttribute('src', image);
          }
        }
        const stackPreview = this.querySelector('.hl-sticky__stack');
        const stackImages = [...this.info.querySelectorAll('.hlst-hero-render')];
        if (stackPreview && stackImages.length) {
          const signature = stackImages.map(image => image.currentSrc || image.src).join('|');
          stackPreview.hidden = false;
          stackPreview.dataset.count = stackImages.length;
          if (this.image) this.image.hidden = true;
          if (this.stackSignature !== signature) {
            this.stackSignature = signature;
            stackPreview.replaceChildren(...stackImages.map(source => {
              const image = document.createElement('img');
              image.src = source.currentSrc || source.src;
              image.alt = '';
              return image;
            }));
          }
        }
        this.setText('.hl-sticky__total', state.ready ? money(state.total) : '');
        this.setText('.hl-sticky__plan', state.ready ? state.plan : this.dataset.loading);
        const selectedPrice = this.info.querySelector('.hl-selected-price');
        const priceContainer = selectedPrice?.parentElement;
        if (selectedPrice && priceContainer) {
          const active = state.ready && state.subscription;
          selectedPrice.hidden = !active;
          priceContainer.classList.toggle('hl-price-has-plan', active);
          if (active) {
            const amount = selectedPrice.querySelector('.hl-selected-price__amount');
            const plan = selectedPrice.querySelector('.hl-selected-price__plan');
            if (amount.textContent !== money(state.total)) amount.textContent = money(state.total);
            if (plan.textContent !== state.plan) plan.textContent = state.plan;
          }
        }
        let shipping = '';
        if (state.ready && this.dataset.country === 'US' && currency === 'USD') {
          shipping = state.total >= 7500 ? this.dataset.shipping : this.dataset.remaining.replace('[amount]', money(7500 - state.total));
        }
        this.setText('.hl-sticky__shipping', shipping);
        const pending = Date.now() < (this.settlingUntil || 0) || Date.now() < (this.lockUntil || 0);
        this.addButton.disabled = !state.ready || state.blocked || pending;
        const label = !state.ready || pending ? this.dataset.loading : state.blocked ? state.button.textContent.trim() : state.subscription ? this.dataset.subscribe : this.dataset.add;
        if (this.addButton.textContent !== label) this.addButton.textContent = label;
        const errorNode = this.info.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
        const error = errorNode?.textContent.trim() || '';
        this.setText('.hl-sticky__error', error);
        this.querySelector('.hl-sticky__error').hidden = !error;
        const preview = document.querySelector('#PBarNextFrame');
        const previewRect = preview?.getBoundingClientRect();
        const previewHeight = previewRect && previewRect.width > 0 && previewRect.bottom >= innerHeight - 2 ? Math.min(64, Math.max(0, innerHeight - previewRect.top)) : 0;
        this.style.setProperty('--hl-preview-bottom', previewHeight + 'px');
        const hasProduct = this.info.getBoundingClientRect().top < innerHeight;
        this.hidden = !hasProduct || this.overlayOpen();
        if (!this.reserve) {
          this.reserve = document.createElement('div');
          this.reserve.setAttribute('aria-hidden', 'true');
          this.after(this.reserve);
        }
        this.reserve.style.height = this.hidden ? '0px' : this.getBoundingClientRect().height + 'px';
      }
      edit() {
        this.info?.querySelector('variant-selects')?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const target = this.info?.querySelector('variant-selects input:checked,variant-selects select');
        if (target) target.focus({ preventScroll: true });
        else this.info?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      add() {
        const state = this.getState();
        if (!state?.ready || state.blocked || Date.now() < (this.lockUntil || 0) || Date.now() < (this.settlingUntil || 0)) return;
        this.lockUntil = Date.now() + 1500;
        this.addButton.disabled = true;
        if (!state.subscription) {
          for (const input of state.form.elements) {
            if (input.name === 'quantity' && input.type === 'hidden') input.value = String(state.quantity);
          }
        }
        state.button.click();
        this.schedule();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-subscription-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-subscription-summary')) {
    customElements.define('hl-subscription-summary', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.attempts = 0;
        this.connectWidget();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.shippingTerms?.remove();
        this.productInfo?.classList.remove('hl-subscription-selected');
      }
      connectWidget() {
        if (!this.isConnected) return;
        const widget = this.productInfo.querySelector('recharge-subscription-widget');
        const upsell = widget?.shadowRoot?.querySelector('recharge-quantity-upsell');
        if (!upsell?.shadowRoot) {
          if (++this.attempts < 120) this.timer = setTimeout(() => this.connectWidget(), 500);
          return;
        }
        this.root = upsell.shadowRoot;
        this.widget = widget;
        this.observer = new MutationObserver(() => this.updateAll());
        this.updateAll();
      }
      updateAll() {
        this.observer.disconnect();
        this.updateShipping();
        this.updateSummary();
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['rc-selected'] });
      }
      updateShipping() {
        if (this.dataset.country !== 'US' || this.dataset.currency !== 'USD') return;
        const threshold = Number(this.dataset.shippingThreshold);
        const options = [...this.root.querySelectorAll('.rc-quantity-upsell-option')].map(option => {
          const header = option.querySelector('.rc-quantity-upsell-option__header');
          const priceText = header?.lastElementChild?.textContent.trim() || '';
          const priceMatch = priceText.replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
          const price = priceMatch ? Math.round(Number(priceMatch[1]) * 100) : NaN;
          const title = option.querySelector('.rc-quantity-upsell-option__title')?.textContent || '';
          const quantity = Number(title.match(/^(\s*)(\d+) products?/i)?.[2]);
          const subscription = Boolean(option.querySelector('input[name="quantityUpsellOption"]')?.value);
          return { option, header, price, quantity, subscription };
        });
        const qualifying = options.filter(item => item.subscription && item.price >= threshold && item.quantity > 0).sort((a, b) => a.quantity - b.quantity)[0];
        if (!this.root.querySelector('[data-hl-shipping-style]')) {
          const style = document.createElement('style');
          style.setAttribute('data-hl-shipping-style', '');
          style.textContent = '.hl-option-shipping{display:flex;align-items:flex-start;gap:6px;margin:8px 0 0;font-family:inherit;font-size:13px;font-weight:500;line-height:1.4;color:#136cba}.hl-option-shipping svg{width:17px;height:17px;flex:0 0 17px;margin-top:1px}';
          this.root.append(style);
        }
        for (const item of options) {
          if (!Number.isFinite(item.price) || !item.header) {
            item.option.querySelector('.hl-option-shipping')?.remove();
            continue;
          }
          let message;
          if (item.price >= threshold) message = this.dataset.shippingQualified;
          else if (qualifying) message = this.dataset.shippingUpgrade.replace('[quantity]', qualifying.quantity);
          else message = this.dataset.shippingRemaining.replace('[amount]', new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((threshold - item.price) / 100));
          let note = item.option.querySelector('.hl-option-shipping');
          if (!note) {
            note = document.createElement('p');
            note.className = 'hl-option-shipping';
            note.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 5h12v12H2zM14 9h4l4 4v4h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg><span></span>';
            item.header.after(note);
          }
          note.querySelector('span').textContent = message;
        }
        if (!this.shippingTerms?.isConnected) {
          this.shippingTerms = document.createElement('p');
          this.shippingTerms.className = 'caption';
          this.shippingTerms.style.cssText = 'margin:8px 0 12px;line-height:1.5;font-size:12px';
          this.shippingTerms.textContent = this.dataset.shippingTerms;
          (this.widget.closest('.shopify-app-block') || this.widget).after(this.shippingTerms);
        }
      }
      updateSummary() {
        const option = this.root.querySelector('[rc-selected]');
        const input = option?.querySelector('input[name="quantityUpsellOption"]');
        const header = option?.querySelector('.rc-quantity-upsell-option__header');
        const titleElement = option?.querySelector('.rc-quantity-upsell-option__title');
        const title = titleElement ? [...titleElement.childNodes].filter(node => node.nodeType === 3).map(node => node.textContent).join('').trim() : '';
        const price = header?.lastElementChild?.textContent.trim();
        const active = Boolean(input?.value && title && price);
        this.hidden = !active;
        this.productInfo.classList.toggle('hl-subscription-selected', active);
        if (!active) return;
        const parts = title.match(/^(\d+) products? every (\d+) days?/i);
        const pattern = parts?.[1] === '1' ? this.dataset.single : this.dataset.bundle;
        const bundle = parts ? pattern.replace('[quantity]', parts[1]).replace('[days]', parts[2]) : title;
        const amount = this.dataset.delivery.replace('[price]', price);
        const bundleNode = this.querySelector('.hl-summary-bundle');
        const priceNode = this.querySelector('.hl-summary-price');
        if (bundleNode.textContent !== bundle) bundleNode.textContent = bundle;
        if (priceNode.textContent !== amount) priceNode.textContent = amount;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-supplement-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-supplement-presenter')) {
  customElements.define('hl-supplement-presenter', class extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.decorate = () => {
        if (!this.isConnected) return;
        const info = document.querySelector('product-info:has([data-hls-product])');
        const root = info?.querySelector('recharge-subscription-widget')?.shadowRoot?.querySelector('recharge-quantity-upsell')?.shadowRoot;
        if (root && !root.querySelector('[data-hls-offer-style]')) {
          const style = document.createElement('style');
          style.setAttribute('data-hls-offer-style','');
          style.textContent = ':host{font-family:Arial,Helvetica,sans-serif!important;--rc-body-font:Arial,Helvetica,sans-serif}*{font-family:Arial,Helvetica,sans-serif!important;letter-spacing:0!important}.rc-quantity-upsell-option{padding:0!important;margin-bottom:12px!important;border-radius:4px!important;border-color:#c5d4df!important}.rc-quantity-upsell-option[rc-selected]{background:#f0f8fd!important;border-color:#1387ce!important}.rc-quantity-upsell-option__label{padding:17px!important}.rc-quantity-upsell-option__header{font-size:13px!important;line-height:1.45!important}.rc-quantity-upsell-option__title{font-size:13px!important;line-height:1.5!important}ul{margin-top:10px!important;margin-bottom:4px!important;display:flex;gap:7px 15px;flex-wrap:wrap}li{font-size:11px!important;line-height:1.5!important}.hl-option-shipping{font-size:11px!important;margin-top:6px!important}button,a{font-size:11px!important}input[type=radio]{accent-color:#137eba}';
          root.append(style);
        }
        if (++this.attempts < 120) this.timer=setTimeout(this.decorate,500);
      };
      this.decorate();
    }
    disconnectedCallback(){clearTimeout(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-visual-polish"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-visual-polish')) {
  customElements.define('hl-visual-polish', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info') || document.querySelector('main product-info');
      this.decorate = () => {
        if (!this.isConnected) return;
        const widget = this.info?.querySelector('recharge-subscription-widget');
        const root = widget?.shadowRoot?.querySelector('recharge-quantity-upsell')?.shadowRoot;
        if (root && !root.querySelector('[data-hl-polish-style]')) {
          const style = document.createElement('style');
          style.setAttribute('data-hl-polish-style','');
          style.textContent = '.rc-quantity-upsell-option{padding:0!important;margin:0 0 13px!important;border-radius:4px!important;border:1px solid #cedbe5!important}.rc-quantity-upsell-option[rc-selected]{background:#eff7fd!important;border-color:#187fae!important;box-shadow:inset 0 0 0 1px #187fae}.rc-quantity-upsell-option__label{padding:13px 14px!important}.rc-quantity-upsell-option__header,.rc-quantity-upsell-option__title{font:700 12px/1.45 Arial,Helvetica,sans-serif!important}.rc-quantity-upsell-option__header{gap:12px!important}.rc-quantity-upsell-option__header>div:last-child{white-space:nowrap;font-size:14px!important}.rc-purchase-option__recommended-badge{background:#142b3b!important;border-color:#142b3b!important;color:#fff!important;border-radius:3px!important;font:700 10px/1.5 Arial,Helvetica,sans-serif!important;padding:2px 7px!important}.rc-purchase-option__best-value-badge{background:#e3f3ff!important;color:#104f77!important;border:1px solid #b2d9f4!important;border-radius:3px!important;font:700 10px/1.5 Arial,Helvetica,sans-serif!important;padding:2px 7px!important}.rc-purchase-option__plan-discount-badge{background:#dceffa!important;color:#125474!important;border:0!important;border-radius:3px!important;font:700 10px/1.4 Arial,Helvetica,sans-serif!important;padding:2px 6px!important;margin-top:3px!important}.hl-option-shipping{margin-top:5px!important;font-size:10px!important;line-height:1.4!important}.hl-option-shipping svg{width:13px!important;height:13px!important;flex-basis:13px!important}.rc-quantity-upsell-option__selector{gap:9px!important}.rc-quantity-upsell-option__title{display:flex!important;align-items:center;flex-wrap:wrap;gap:3px 8px!important}.rc-purchase-option__plan-discount-badge{margin-top:0!important}rc-benefits{display:block;margin-top:6px}rc-benefits::part(rc-benefits__list){display:flex!important;flex-wrap:wrap;gap:4px 14px!important;margin:5px 0!important;padding:0!important;font-size:11px!important;line-height:1.45!important}rc-learn-more::part(rc-learn-more__trigger-compact){font:11px/1.4 Arial,Helvetica,sans-serif!important;margin-top:5px!important}';
          root.append(style);
        }
        if (root) {
          root.querySelectorAll('rc-benefits').forEach(host => {
            if (!host.shadowRoot || host.shadowRoot.querySelector('[data-hl-polish-benefits]')) return;
            const style=document.createElement('style');style.setAttribute('data-hl-polish-benefits','');
            style.textContent='ul{display:flex!important;flex-wrap:wrap;gap:4px 12px!important;padding:0!important;margin:6px 0 2px!important}li{font:11px/1.5 Arial,Helvetica,sans-serif!important;margin:0!important;gap:5px!important}svg,img{width:13px!important;height:13px!important}';host.shadowRoot.append(style);
          });
        }
        if (document.querySelector('[data-hlst-product]')) {
          document.querySelectorAll('.jdgm-review-widget').forEach(widget => {
            const empty=widget.textContent.includes('Be the first to write a review') && !widget.querySelector('.jdgm-rev');
            const section=widget.closest('.shopify-section');
            if (empty && section && section.querySelectorAll('.shopify-app-block').length===1) section.hidden=true;
            else if (!empty && section?.hidden) section.hidden=false;
          });
        }
      };
      this.decorate();
      this.timer=setInterval(this.decorate,700);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
